<template>
<div>
    <!-- BootstrapVue Done
    <base-header class="pb-6 pb-8 pt-5 pt-md-8 bg-gradient-dark">
    </base-header> -->
    <!-- <b-card> -->
    <!-- <b-container fluid class="mt--6"> -->
    <b-row>
        <b-col>
            <div class="card-wrapper">
                <card>
                    <card>
                        <b-row>
                            <b-col sm="4"> PILIH TAHUN </b-col>
                            <b-col sm="1"> :</b-col>
                            <b-col sm="7">
                                <b-form-select id="tahun" name="tahun" value-field="value" text-field="text" v-model="obj.tahun" :options="ObjTahun" @change="runMethod()" style="width: 20%" aria-describedby="input-2-live-feedback">
                                    <template #first>
                                        <b-form-select-option :value="null">-- Pilihan --</b-form-select-option>
                                    </template>
                                </b-form-select>
                            </b-col>
                        </b-row>
                        <br />
                        <div v-show="showDiv">
                            <b-row>
                                <b-col sm="4"> PROSES YANG BERLAKU </b-col>
                                <b-col sm="1"> :</b-col>
                                <b-col sm="7">
                                    <b-form-select id="tahun" name="tahun" value-field="value" text-field="text" v-model="obj.elemenId" :options="objProcess" @change="runMethod2()" style="width: 70%" aria-describedby="input-2-live-feedback">
                                        <template #first>
                                            <b-form-select-option :value="null">-- Pilihan --</b-form-select-option>
                                        </template>
                                    </b-form-select>
                                </b-col>
                            </b-row>
                        </div>
                    </card>
                    <br />
                    <div v-show="showDivElemen">

                            <b-col>
                                <card>
                                    <b-row v-if="obj.elemenId == 17">
                                        <tempGajisblm2003 @batal="batal"></tempGajisblm2003>
                                    </b-row>
                                    <b-row v-if="obj.elemenId == 1">
                                        <tempGajiLantikanPertama  @batal="batal"></tempGajiLantikanPertama>
                                    </b-row>
                                    <b-row v-if="obj.elemenId == 2" >
                                        <temPergGajiBiasa :tahun="obj.tahun" @batal="batal"></temPergGajiBiasa>
                                    </b-row>
                                    <b-row v-if="obj.elemenId == 11">
                                        <tempPergGajiBiasaXBPK :elemenId="obj.elemenId" :tahun="obj.tahun" @batal="batal"></tempPergGajiBiasaXBPK>
                                    </b-row>
                                    <b-row v-if="obj.elemenId == 3">
                                        <tempPergGajiAnjakan :elemenId="obj.elemenId" :tahun="obj.tahun" @batal="batal"></tempPergGajiAnjakan>
                                    </b-row>
                                    <b-row v-if="obj.elemenId == 4">
                                        <tempPenGajiNaikPangkat :elemenId="obj.elemenId" :tahun="obj.tahun" @batal="batal"></tempPenGajiNaikPangkat>
                                    </b-row>
                                    <b-row v-if="obj.proses == 5">
                                        <tempPerubahanTPG></tempPerubahanTPG>
                                    </b-row>
                                    <b-row v-if="obj.elemenId == 6">
                                        <tempGajiKadarTetap></tempGajiKadarTetap>
                                    </b-row>
                                    <b-row v-if="obj.elemenId == 7">
                                        <tempPelarasan072007 :elemenId="obj.elemenId" :tahun="obj.tahun" @batal="batal"></tempPelarasan072007>
                                    </b-row>
                                    <b-row v-if="obj.elemenId == 8">
                                        <tempPelarasan012012 :elemenId="obj.elemenId" :tahun="obj.tahun" @batal="batal"></tempPelarasan012012>
                                    </b-row>
                                    <b-row v-if="obj.elemenId == 9">
                                        <tempPelarasan052013 :elemenId="obj.elemenId" :tahun="obj.tahun" @batal="batal"></tempPelarasan052013>
                                    </b-row>
                                    <b-row v-if="obj.elemenId == 21" >
                                        <tempTukarLantik :elemenId="obj.elemenId" :tahun="obj.tahun" @batal="batal"></tempTukarLantik>
                                    </b-row>
                                    <b-row v-if="obj.proses == 15">
                                        <tempPenyeragamanGredPP012016></tempPenyeragamanGredPP012016>
                                    </b-row>
                                    <!-- <b-row v-if="obj.proses == 12">
                                        <tempPenetapanGPT></tempPenetapanGPT>
                                    </b-row> -->
                                    <b-row v-if="obj.elemenId == 13">
                                        <tempPenNaikPangkatMohonKUP :elemenId="obj.elemenId" :tahun="obj.tahun" @batal="batal"></tempPenNaikPangkatMohonKUP>
                                    </b-row>
                                    <b-row v-if="obj.elemenId  == 16">
                                        <tempKGTKhas :elemenId="obj.elemenId" :tahun="obj.tahun" @batal="batal"></tempKGTKhas>
                                    </b-row>
                                    <b-row v-if="obj.elemenId == 18">
                                        <tempMeninggalDunia :elemenId="obj.elemenId" :tahun="obj.tahun" @batal="batal"></tempMeninggalDunia>
                                    </b-row>
                                    <!-- <b-row v-if="obj.elemenId == 19">
                                        <tempBersara :elemenId="obj.elemenId" :tahun="obj.tahun" @batal="batal"></tempBersara>
                                    </b-row> -->
                                    <b-row v-if="obj.elemenId ==23" class="w-50">
                                        <tempPengiraanBGE :elemenId="obj.elemenId" :tahun="obj.tahun" @batal="batal"></tempPengiraanBGE>
                                    </b-row>
                                    <b-row v-if="obj.elemenId == 22">
                                        <tempRasionalisasi :elemenId="obj.elemenId" :tahun="obj.tahun" @batal="batal"></tempRasionalisasi>
                                    </b-row>
                                    <b-row v-if="obj.elemenId == 24">
                                        <tempSSPAFasa1 :elemenId="obj.elemenId" :tahun="obj.tahun" @batal="batal"></tempSSPAFasa1>
                                    </b-row>
                                    <b-row v-if="obj.elemenId == 25">
                                        <tempSSPAFasa2 :elemenId="obj.elemenId" :tahun="obj.tahun" @batal="batal"></tempSSPAFasa2>
                                    </b-row>
                                    <b-row v-if="obj.elemenId == 26">
                                        <tempPengiraanKUPSSPA :elemenId="obj.elemenId" :tahun="obj.tahun" @batal="batal"></tempPengiraanKUPSSPA>
                                    </b-row>
                                </card>
                            </b-col>

                    </div>

                </card>
            </div>
        </b-col>
    </b-row>
    <!-- </b-container> -->
    <!-- </b-card> -->
</div>
</template>

<script>
import moment from "moment";
import tempRasionalisasi from "@/views/Skg/tempRasionalisasi.vue";
import tempBersara from "@/views/Skg/tempBersara.vue";
import tempKGTKhas from "@/views/Skg/tempKGTKhas.vue";
import tempMeninggalDunia from "@/views/Skg/tempMeninggalDunia.vue";
import tempPenNaikPangkatMohonKUP from "@/views/Skg/tempPenNaikPangkatMohonKUP.vue";
import tempPenetapanGPT from "@/views/Skg/tempPenetapanGPT.vue";
import tempPenyeragamanGredPP012016 from "@/views/Skg/tempPenyeragamanGredPP012016.vue";
import tempTukarLantik from "@/views/Skg/tempTukarLantik.vue";
import tempPelarasan032016 from "@/views/Skg/tempPelarasan032016.vue";
import tempPelarasan052013 from "@/views/Skg/tempPelarasan052013.vue";
import tempPelarasan012012 from "@/views/Skg/tempPelarasan012012.vue";
import tempPelarasan072007 from "@/views/Skg/tempPelarasan072007.vue";
import tempGajiKadarTetap from "@/views/Skg/tempGajiKadarTetap.vue";
import tempPerubahanTPG from "@/views/Skg/tempPerubahanTPG.vue";
import tempPenGajiNaikPangkat from "@/views/Skg/tempPenGajiNaikPangkat.vue";
import tempPergGajiAnjakan from "@/views/Skg/tempPergGajiAnjakan.vue";
import temPergGajiBiasa from "@/views/Skg/temPergGajiBiasa.vue";
import tempPergGajiBiasaXBPK from "@/views/Skg/tempPergGajiBiasa(XBPK).vue";
import tempGajiLantikanPertama from "@/views/Skg/tempGajiLantikanPertama.vue";
import tempGajisblm2003 from "@/views/Skg/tempGajisblm2003.vue";
import templatetest from "@/views/Skg/templatetest.vue";
import tempPengiraanBGE from "@/views/Skg/tempPengiraanBGE.vue";
import tempSSPAFasa1 from "@/views/Skg/tempSSPAFasa1.vue";
import tempSSPAFasa2 from "@/views/Skg/tempSSPAFasa2.vue";
import tempPengiraanKUPSSPA from "@/views/Skg/tempPengiraanKUPSSPA.vue";
import GetselenggaraService from "@/services/selenggaraService.js";
import GetsalaryService from "@/services/salaryService.js";
import swal from "sweetalert2";
import Store from "@/store";
export default {
    components: {
        templatetest,
        tempGajisblm2003,
        tempGajiLantikanPertama,
        temPergGajiBiasa,
        tempPergGajiBiasaXBPK,
        tempPergGajiAnjakan,
        tempPenGajiNaikPangkat,
        tempPerubahanTPG,
        tempGajiKadarTetap,
        tempPelarasan072007,
        tempPelarasan012012,
        tempPelarasan052013,
        tempPelarasan032016,
        tempTukarLantik,
        tempPenyeragamanGredPP012016,
        tempPenetapanGPT,
        tempPenNaikPangkatMohonKUP,
        tempKGTKhas,
        tempMeninggalDunia,
        tempBersara,
        tempRasionalisasi,
        tempPengiraanBGE,
        tempSSPAFasa1,
        tempSSPAFasa2,
        tempPengiraanKUPSSPA,
    },
    data() {
        return {
            tahun: "",
            showDiv: false,
            showDivElemen: false,
            obj: {},
            objtahunLatest: {},
            ValElemen:{},
            ObjTahun: [{
                    text: "2011",
                    value: 1,
                },
                {
                    text: "2012",
                    value: 2,
                },
                {
                    text: "2013",
                    value: 3,
                },
            ],
            objProcess: [{
                    text: "GAJI AKHIR PADA 31 DISEMBER 2002",
                    value: 1,
                },
                {
                    text: "GAJI LANTIKAN PERTAMA",
                    value: 2,
                },
                {
                    text: "PERGERAKAN GAJI TAHUNAN (BIASA)",
                    value: 3,
                },
            ],
            cektahun: null,
        };
    },
    methods: {
        runMethod() {
            this.showDiv= true;
            this.showDivElemen = false;
            //this.obj.proses=0;
            console.log("this.obj.proses", this.obj.proses);
           // console.log("this.coid",this.coid)
            let Search2 = {
                coid: Store.state.MaklumatPeribadi.coid,
                // tahun: this.obj.tahun,
            };

            GetsalaryService.getLatestTahun(Search2)
                .then((resp) => {
                    this.objtahunLatest = resp.data;
                })
                .catch((err) => {
                    console.log(err);
                })
                .then(() => {
                    console.log("objtahunLatest", this.objtahunLatest.tahun);
                    if (this.objtahunLatest.Status == 1) {
                        if (this.obj.tahun > this.objtahunLatest.tahun) {
                            this.cektahun = Number(this.objtahunLatest.tahun) + 1;
                            console.log("cektahun", this.cektahun);

                            if (this.obj.tahun > this.cektahun) {
                                console.log("kat disini");
                                this.showDiv = false;
                                swal.fire({
                                    title: `SILA PILIH TAHUN YANG TEPAT.`,
                                    buttonsStyling: true,
                                    icon: "success",
                                });
                            } else {
                                this.showDiv = true;
                                console.log("dekat else dalam");
                                let Search = {
                                    tahun: this.obj.tahun,
                                };

                                GetsalaryService.getElemen(Search)
                                    .then((resp) => {
                                        this.objProcess = resp.data;
                                        //console.log(this.SchmOfServList);
                                    })
                                    .catch((err) => {
                                        console.log(err);
                                    });
                                console.log("obj", this.obj);
                            }
                        } else if (this.obj.tahun < this.objtahunLatest.tahun) {
                            this.showDiv = false;
                            console.log("disini");
                            swal.fire({
                                title: `SILA PILIH TAHUN YANG TEPAT.`,
                                buttonsStyling: true,
                                icon: "success",
                            });
                        } else {
                            console.log("dekat else luar");
                            this.showDiv = true;
                            let Search = {
                                tahun: this.obj.tahun,
                            };

                            GetsalaryService.getElemen(Search)
                                .then((resp) => {
                                    this.objProcess = resp.data;
                                    this.showDivElemen = true;
                                    //console.log(this.SchmOfServList);
                                })
                                .catch((err) => {
                                    console.log(err);
                                });
                            //console.log("obj", this.obj);
                        }
                    } else {
                        this.showDiv = true;
                        let Search = {
                            tahun: this.obj.tahun,
                        };

                        GetsalaryService.getElemen(Search)
                            .then((resp) => {
                                this.objProcess = resp.data;
                                this.showDivElemen = true;
                                //console.log(this.SchmOfServList);
                            })
                            .catch((err) => {
                                console.log(err);
                            });
                    }
                });
            //console.log("obj",this.obj);
        },
        runMethod2() {
            //alert();
            // let Search2 = {
            //     coid: Store.state.MaklumatPeribadi.coid,
            //      tahun: this.obj.tahun,
            //      elemenId: this.obj.elemenId,
            // };
            // console.log("Search2",Search2);
            // GetsalaryService.ValElemen(Search2)
            //     .then((resp) => {
            //         this.ValElemen = resp.data;
            //     })
            //     .catch((err) => {
            //         console.log(err);
            //     }).then(() => {
            //         console.log("val Elemen",this.ValElemen)
            //         if (this.ValElemen.Status==2) {
            //                     //console.log("kat disini");
            //                     this.showDiv = false;
            //                     swal.fire({
            //                         title: this.ValElemen.details,
            //                         buttonsStyling: true,
            //                         icon: "error",
            //                     });
            //                     this.showDivElemen = false;
            //                     this.showDiv=false;
            //                     this.obj.elemenId='';
            //                     this.obj.tahun='';
            //                 } else {
            //                     this.showDivElemen = true;
            //                 }
            //     });
            //console.log("this.obj.proses", this.obj.proses);
            //console.log("this.obj.elemenId", this.obj.elemenId);
            this.showDivElemen = true;
        },
        batal() {
            this.$emit("batal");
        },
        Simpan() {
            this.obj.coid = Store.state.MaklumatPeribadi.coid
            console.log("log", this.obj);

            GetsalaryService.setElemenPGT(this.obj).then((resp) => {
                this.StatusSimpan = resp.data;
            });
        }
    },
    computed: {
        coid() {
            return Store.state.MaklumatPeribadi[0].coid;
        },
    },
    created() {
        // let search = {
        //     currentPage: 1,
        //     coid: Store.state.MaklumatPeribadi.coid,
        // };
        // GetsalaryService.getLatestTahun(search)
        //     .then((resp) => {

        //         this.objtahunLatest = resp.data;
        //         console.log("value apa", this.objtahunLatest);
        //     })
        //     .then(() => {
        //         if (this.objtahunLatest.Status == 1) {

        //             this.tahun = this.objtahunLatest.tahun;
        //         } else {

        //             console.log("DtLantikanPertama",Store.state.MaklumatPeribadi.ICNo);
        //             this.tahun = moment(Store.state.MaklumatPeribadi.DtLantikanPertama,"DD-MM-YYYY").format("YYYY");

        //         }

        //         console.log("tahun moment", this.tahun);

        //     })
        //     .catch((err) => {
        //         console.log(err);
        //     });

        // let Search = {
        //         tahun: this.tahun,
        //     };

        GetselenggaraService.getTahun()
            .then((resp) => {
                this.ObjTahun = resp.data;
                //console.log("AAAA", this.ObjTahun);
            })
            .catch((err) => {
                console.log(err);
            });

    },
};
</script>
